import {
  useQuery,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

export function useApi<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryResult<TData, TError> {
  return useQuery({
    ...options,
    // preventing default true for this to save api calls
    refetchInterval: options.refetchInterval || false,
    staleTime: options.staleTime || 5 * 60 * 1000,
    retry: 3,
    refetchOnWindowFocus: false,
  });
}
